/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ActionIcon } from './../SVGIcon';
import styles from '../../styles';

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 100;
  overflow: auto;
`;

const ModalBackdrop = styled.div`
  position: fixed;

  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(126,140,153,.8);
`;

const ModalContainer = styled.div`
  position: relative;
  top: 3rem;
  padding: 1rem 0;
  margin: 0 auto 0 auto;
  z-index: 1;

  @media (min-width: 45rem){
    margin: 0 auto 0 auto;
    width: 80%;
    max-width: 45rem;
    height: 33.7857rem;
  }
  @media (min-width: 22.8571rem) and (max-width: 34.2857rem) {
    margin: 0 1.1429rem
  }
`;

const CloseButton = styled.div`
  width: 2rem;
  margin-left: auto;

  padding-bottom: .5rem;
  cursor: pointer;
`;

const ModalBody = styled.div`
  ${styles.borders.card};
`;


class Modal extends React.Component {
  static propTypes = {
    onClose: PropTypes.func,
    children: PropTypes.node
  }

  constructor(props) {
    super(props);
    this.clickOutside = this.clickOutside.bind(this);
  }

  clickOutside(event) {
    if (this.modalRef && !this.modalRef.contains(event.target)) {
      this.props.onClose(event);
    }
  }

  UNSAFE_componentWillMount() {
    document.body.style.overflow = 'hidden';
  }

  componentWillUnmount() {
    document.body.style.overflow = null;
  }

  render() {
    const { children, onClose } = this.props;

    return (
      <Wrapper>
        <ModalBackdrop onClick={this.clickOutside} />
        <ModalContainer onClick={this.clickOutside}>
          <CloseButton>
            <ActionIcon size='2rem' onClick={onClose} icon='close' />
          </CloseButton>
          <ModalBody innerRef={(ref) => {
            return this.modalRef = ref;
          }}>
            {children}
          </ModalBody>
        </ModalContainer>
      </Wrapper>
    );
  }
}

export default Modal;
